import { inject, Injectable } from '@angular/core';
import { DataStore } from '../../../storage/data-store/data-store';
import { ViewModelsService } from '../../../viewmodels/viewmodel-service.type';
import { Uuid } from '../../../domain/model/uuid/uuid.type';
import { AnimalWeighingViewModel } from '../../../viewmodels/animal-weighings/animal-weighing.viewmodel';
import { recordAttemptGet } from '../../../functions/record.function';
import { SectionIdTrialIdUuid } from '../../../viewmodels/section-id-trial-id-uuid';
import { SectionOverviewViewModel } from '../../../viewmodels/section-overview/section-overview.viewmodel';
import { BatchWeighingViewModel } from '../../../viewmodels/shared/batch-weighing.viewmodel';
import { TrialOverviewViewModel } from '../../../viewmodels/trials/trial-overview.viewmodel';

@Injectable({
  providedIn: 'root',
})
export class DataStoreReaderService implements ViewModelsService {
  private readonly store = inject(DataStore);

  getAnimalWeighingViewModels(id: Uuid): AnimalWeighingViewModel {
    const viewModel = recordAttemptGet(this.store.animalWeighingsViewModel(), id.asString());
    if (!viewModel) {
      console.log('AnimalWeighingViewModel not found for id: ', id.asString());
      throw new Error(`AnimalWeighingViewModel not found for id: ${id.asString()}`);
    }
    return viewModel;
  }

  getSectionOverviewViewModel(sectionIdAndTrialId: SectionIdTrialIdUuid): SectionOverviewViewModel {
    const viewModel = recordAttemptGet(this.store.sectionOverviewViewModelFromStore(), sectionIdAndTrialId.toConcatedKey());
    if (!viewModel) {
      throw new Error(`SectionWeighingViewModel not found for key: ${sectionIdAndTrialId}`);
    }
    return viewModel;
  }

  getBatchWeighingViewModel(id: Uuid): BatchWeighingViewModel {
    const viewModel = recordAttemptGet(this.store.batchWeighingsViewModel(), id.asString());
    if (!viewModel) {
      throw new Error(`BatchWeighingViewModel not found for id: ${id}`);
    }
    return viewModel;
  }

  getTrialOverviewViewModel(): TrialOverviewViewModel[] {
    const viewModel = this.store.trialOverviewViewModel();
    if (!viewModel) {
      throw new Error(`TrialOverviewViewModel not found`);
    }
    return viewModel;
  }
}
